import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { PhoneSearchInput: searchColors } = phoneColorKeys.Phone

export enum PhoneSearchInputVariants {
  Disabled = 'disabled',
  Ready = 'ready',
  Filled = 'filled',
}

const PhoneSearchInputParts = [
  'container',
  'input',
  'inputRightElement',
  'text',
] as const

const helpers = createMultiStyleConfigHelpers(PhoneSearchInputParts)
export const PhoneSearchInput = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      paddingBottom: '1rem',
      gap: '1.25rem',
      borderBottom: '0.25rem solid',
      borderColor: searchColors.Container.BorderColor,
    },
    input: {
      display: 'flex',
      flex: 1,
      color: searchColors.Input.FontColor,
      ...textStyles[textStyleKeys.H3],
      _placeholder: {
        color: searchColors.Input.Placeholder.FontColor,
        ...textStyles[textStyleKeys.H3],
        textAlign: 'center',
      },
      //TODO this will overlap on the right with the clear btn
      paddingRight: 0,
    },
    inputRightElement: {
      height: 'full',
      marginRight: '0.75rem',
      opacity: 0,
      transition: 'opacity 0.15s ease-in-out',
      cursor: 'default',
    },
    text: {
      textStyle: textStyleKeys.Body2_Bold,
    },
  },
  variants: {
    [PhoneSearchInputVariants.Disabled]: {
      container: {
        borderColor: searchColors.Container.Disabled.BorderColor,
      },
      input: {
        _placeholder: {
          color: searchColors.Input.Disabled.Placeholder.FontColor,
          ...textStyles[textStyleKeys.H2],
        },
      },
    },
    [PhoneSearchInputVariants.Ready]: {},
    [PhoneSearchInputVariants.Filled]: {
      inputRightElement: {
        opacity: '100%',
        cursor: 'pointer',
      },
    },
  },
})

export const usePhoneSearchInputStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof PhoneSearchInputParts>(
    getName({ PhoneSearchInput }),
    props,
  )
}
